import { render } from "./ITEM_CONVERTED_TO_EPIC.vue?vue&type=template&id=ba44c43a&scoped=true&ts=true"
import script from "./ITEM_CONVERTED_TO_EPIC.vue?vue&type=script&lang=ts"
export * from "./ITEM_CONVERTED_TO_EPIC.vue?vue&type=script&lang=ts"

import "./ITEM_CONVERTED_TO_EPIC.vue?vue&type=style&index=0&id=ba44c43a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba44c43a"]])

export default __exports__